import { Flex, Skeleton, Typography } from 'antd';
import { useSearchProductsInfiniteQuery } from '../../../../store/products/productsApi';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import { selectActiveFilters, setFilter } from '../../../../store/products/slice';
import ActiveFiltersBar from './ActiveFiltersBar';
import FacetDropdown from './FacetDropdown';
import * as Styles from './styles';

interface IFiltersProps {
  showTitle?: boolean;
  selectSize?: SizeType;
}

const SHOPIFY_STATUS_FACET = {
  key: { key: 'shopifyStatus', displayName: 'Shopify Status' },
  values: [
    { id: 'ACTIVE', value: 'Active' },
    { id: 'DRAFT', value: 'Draft' },
  ],
};

const GENDER_FACET = {
  key: { key: 'gender', displayName: 'Gender' },
  values: [
    { id: 'MEN', value: 'MEN' },
    { id: 'WOMEN', value: 'WOMEN' },
    { id: 'UNISEX', value: 'UNISEX' },
  ],
};

const Filters = ({ showTitle = true, selectSize = 'middle' }: IFiltersProps) => {
  const dispatch = useAppDispatch();
  const activeFilters = useAppSelector(selectActiveFilters);

  const { data, isLoading } = useSearchProductsInfiniteQuery({
    filters: activeFilters,
  });

  const facets = data?.pages[data.pages.length - 1]?.facets || [];
  const hasGenderFacet = facets.some(facet => facet.key.key === 'gender');

  const getSelectedValues = (fieldName: string): Array<string> => {
    const filter = activeFilters.find(f => f.field === fieldName);
    return filter ? filter.value.split(',') : [];
  };

  const handleFilterChange = (fieldName: string, values: Array<string>, filterType?: string) => {
    dispatch(setFilter({ field: fieldName, values, filterType }));
  };

  return (
    <Styles.Wrapper>
      {showTitle && <Typography.Paragraph strong={true}>Product Filters</Typography.Paragraph>}
      <Flex gap="middle" wrap>
        <FacetDropdown
          facet={SHOPIFY_STATUS_FACET}
          selectedValues={getSelectedValues('shopifyStatus')}
          onChange={values => handleFilterChange('shopifyStatus', values, 'EQ')}
          size={selectSize}
        />
        {!hasGenderFacet && (
          <FacetDropdown
            facet={GENDER_FACET}
            selectedValues={getSelectedValues('gender')}
            onChange={values => handleFilterChange('gender', values)}
            size={selectSize}
          />
        )}
        {isLoading &&
          Array.from({ length: 4 }).map((_, i) => (
            <Skeleton.Button
              key={i}
              active
              size="small"
              shape="round"
              style={{ width: 150, height: 32 }}
            />
          ))}
        {facets.map(facet => (
          <FacetDropdown
            key={facet.key.key}
            facet={facet}
            selectedValues={getSelectedValues(facet.key.key)}
            onChange={values => handleFilterChange(facet.key.key, values)}
            size={selectSize}
          />
        ))}
      </Flex>
      <ActiveFiltersBar />
    </Styles.Wrapper>
  );
};

export default Filters;
